<template>
  <section class="ugc-custom-checkerboard-create">
    <div class="ugc-custom-checkerboard-create-wrapper">
      <button
        type="button"
        class="button ugc-tray-wrapper-button"
        :style="{ 'background-image': `url(${ $store.state.endPoints.customizer.customsAssets }/images/customizer/checkerboard_cta_bg.png)`}"
        :disabled="disableButton"
        @click="clicked"
      >
        {{ textLabel }}
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: "custom-checkerboard-create",
  props: {
    disableButton: {
      type: Boolean,
      default: false,
    },
    textLabel: {
      type: String,
      required: true,
    },
  },
  methods: {
    setDataLayer() {
      if (this.$store.getters['utils/useEcomDataLayerFormat']) {
        this.$customizerDataLayer.logAnalyticsEvent({ type: this.$customizerDataLayer.types.customizerCreateYourOwn, eventLabel: 'Custom Checkerboard' });
      }
    },
    clicked() {
      this.setDataLayer();
      this.$store.commit("ugc/tempData/SET_ACTIVE_UGC_INDEX", "ugc");
      this.$store.commit('customCheckerboard/RESET_NAVIGATION');
      this.$store.commit('customCheckerboard/RESET_CANVAS');
      this.$modal.show("customCheckerboard");
    }
  },
};
</script>
